module.exports = __webpack_public_path__ + "img/icon_ticket_expired.0fba28fe.png";